import { createActionTypes } from "@helpers/redux-helpers";

export const getCreatorStreamsActionTypes = createActionTypes(
  "creatorStreams/getList",
);

export const updateCreatorStreamReminderType = "creatorStreams/reminder";

export const clearCreatorStreamsType = "creatorStreams/clear";
